// @flow
import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';

import type { QuestionType, ThemeType } from 'types/Faq';

export type StateProps = {
  themes?: Array<ThemeType>,
  questions: Array<QuestionType>
};

type Props = {
  match: {
    params: {
      slugTheme: string
    }
  }
} & StateProps;

class ContactList extends PureComponent<Props> {
  static defaultProps = {
    theme: ''
  };

  renderQuestions = (filteredQuestions: Array<QuestionType>): any => {
    const { themes } = this.props;

    if (!themes || themes.length === 0) {
      return null;
    }

    return filteredQuestions.map((question, index) => {
      const filteredTheme = themes.filter(theme => theme.id === question.theme);

      if (question.link) {
        return (
          <Link to={question.link} key={index} className="link-chevron link-chevron--din" data-label="">
            <span>{question.title}</span>
            <i className="icon icon-chevron-right"></i>
          </Link>
        );
      }

      return (
        <Link
          to={`/faq/${filteredTheme[0].slug}/${question.slug}`}
          key={index}
          className="link-chevron link-chevron--din"
          data-label=""
        >
          <span>{question.title}</span>
          <i className="icon icon-chevron-right"></i>
        </Link>
      );
    });
  };

  render() {
    const { questions, themes } = this.props;
    const { slugTheme } = this.props.match.params;
    if (slugTheme === 'nous-contacter') {
      return null;
    }

    if (!themes || themes.length === 0) {
      return null;
    }

    const filteredThemes = themes.filter(theme => theme.slug === slugTheme);

    if (filteredThemes.length === 0) {
      return null;
    }

    const filteredQuestions = questions.filter(question => question.theme === filteredThemes[0].id);
    if (filteredThemes[0].page_liee && filteredThemes[0].page_liee_link) {
      filteredQuestions.push({
        id: filteredThemes[0].page_liee,
        theme: filteredThemes[0].id,
        link: filteredThemes[0].page_liee_link,
        title: 'Voir la rubrique dédiée',
        content: '',
        label: {
          name: filteredThemes[0].name,
          slug: filteredThemes[0].slug,
          id: filteredThemes[0].id
        },
        meta_description: '',
        meta_title: '',
        slug: '',
        typeFlow: 'QuestionType'
      });
    }

    return (
      <>
        {filteredQuestions.length > 0 && (
          <div className="block-contact">
            <div className="box block-contact__faq mb-6">
              <h3>Cela pourrait vous être utile</h3>
              {this.renderQuestions(filteredQuestions)}
            </div>
          </div>
        )}
      </>
    );
  }
}

export default ContactList;
